/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsUserUserEmailListResponse
 */
export interface RevisdomAPIViewModelsUserUserEmailListResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof RevisdomAPIViewModelsUserUserEmailListResponse
     */
    emails?: Array<string> | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsUserUserEmailListResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsUserUserEmailListResponse(value: object): value is RevisdomAPIViewModelsUserUserEmailListResponse {
    return true;
}

export function RevisdomAPIViewModelsUserUserEmailListResponseFromJSON(json: any): RevisdomAPIViewModelsUserUserEmailListResponse {
    return RevisdomAPIViewModelsUserUserEmailListResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserUserEmailListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsUserUserEmailListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'emails': json['emails'] == null ? undefined : json['emails'],
    };
}

export function RevisdomAPIViewModelsUserUserEmailListResponseToJSON(json: any): RevisdomAPIViewModelsUserUserEmailListResponse {
    return RevisdomAPIViewModelsUserUserEmailListResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserUserEmailListResponseToJSONTyped(value?: RevisdomAPIViewModelsUserUserEmailListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emails': value['emails'],
    };
}

